module.exports = __webpack_public_path__ + "static/img/5-1.43bebdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/5-1.png
// module id = uBre
// module chunks = 1